import React, { useState } from "react";
import Login from "./Login";
import Signup from "./Signup";
import { Container } from "reactstrap";

const Auth = (props) => {
  const [currentForm, setCurrentForm] = useState("login");

  return (
    <>
      <Container>
        {currentForm === "login" ? (
          <Login
            updateToken={props.updateToken}
            setCurrentForm={setCurrentForm}
          />
        ) : (
          <Signup
            updateToken={props.updateToken}
            setCurrentForm={setCurrentForm}
          />
        )}
      </Container>
        
    </>
  );
};

export default Auth;
